import BoletimSection from "../BoletimSection/BoletimSection";
import Card from "./Card/Card";
import styles from "./NotasSemestre.module.css";

function NotasSemestre({ final_grade, freq, ranking, subjects_grades, showAol = false, showNp = false }) {
	function getGridTemplateCol() {
		if (!showAol && !showNp) {
			return "2fr repeat(2, 0.5fr) repeat(3, 1fr)";
		}
		else if (showAol && !showNp) {
			return "2fr repeat(3, 0.5fr) repeat(3, 1fr)";
		}
		else {
			return "2fr repeat(5, 0.5fr) repeat(3, 1fr)";
		}
	}
	
	return (
		<BoletimSection
			title={"Notas do Semestre"}
			icon={"medal"}
		>
			<div className={styles.cardsContainer}>
				<Card
					label={"Nota geral"}
					value={final_grade ? final_grade.toFixed(2) : "-"}
				/>
				<Card
					label={"Frequência geral"}
					value={freq ? `${freq.toFixed(2)}%` : "-"}
				/>
				<Card
					label={"Colocação na turma"}
					value={ranking ? `${ranking}°`: "-"}
				/>
			</div>
			<div className={styles.gradesTableContainer}>
				<div
					key={`notas-semestre-header`}
					className={[styles.row, styles.header].join(" ")}
					style={{ gridTemplateColumns: getGridTemplateCol() }}
				>
					<div className={styles.td}>Disciplina</div>
					{showNp && <div className={styles.td}>NP1</div>}
					<div className={styles.td}>A1</div>
					{showAol && <div className={styles.td}>AOL</div>}
					{showNp && <div className={styles.td}>NP2</div>}
					<div className={styles.td}>A2</div>
					<div className={styles.td}>Nota final</div>
					<div className={styles.td}>Frequência</div>
					<div className={styles.td}>Resultado</div>
				</div>
				{subjects_grades.map(
					(
						{
							subject,
							np1_grade,
							a1_grade,
							aol_grade,
							np2_grade,
							a2_grade,
							final_grade,
							freq,
							approved,
						},
						i
					) => {
						const rowStyles =
							i % 2 === 1
								? styles.row
								: [styles.row, styles.dark].join(" ");
						const resultStyles = approved
							? [styles.td, styles.approved].join(" ")
							: [styles.td, styles.reproved].join(" ");
						return (
							<div
								key={`notas-semestre-grade-${i}`}
								className={rowStyles}
								style={{ gridTemplateColumns: getGridTemplateCol() }}
							>
								<div
									className={[styles.td, styles.subject].join(
										" "
									)}
								>
									{subject}
								</div>
								{showNp && <div className={styles.td}>
									{typeof np1_grade === 'number' ? np1_grade.toFixed(2) : np1_grade}
								</div>}
								<div className={styles.td}>
									{a1_grade.toFixed(2)}
								</div>
								{showAol && <div className={styles.td}>
									{typeof aol_grade === 'number' ? aol_grade.toFixed(2) : aol_grade}
								</div>}
								{showNp && <div className={styles.td}>
									{typeof np2_grade === 'number' ? np2_grade.toFixed(2) : np2_grade}
								</div>}
								<div className={styles.td}>
									{typeof a2_grade === 'number' ? a2_grade.toFixed(2) : a2_grade}
								</div>
								<div className={styles.td}>
									{final_grade.toFixed(2)}
								</div>
								<div className={styles.td}>
									{freq.toFixed(2)}%
								</div>
								<div className={resultStyles}>{approved ? "Aprovado" : "Reprovado"}</div>
							</div>
						);
					}
				)}
			</div>
		</BoletimSection>
	);
}

export default NotasSemestre;
